import {
  ADD_CLIPBOARD_PRODUCT_CODES,
  AddClipBoardProductCodesAction,
  CLEAR_CLIPBOARD,
  ProductIdCodes,
  RESET_CLIPBOARD,
  SET_CLIPBOARD_PRODUCT_CODES,
  SetClipBoardProductCodesAction,
  VERIFY_CLIPBOARD_PRODUCT_CODES,
} from "./ClipBoardTypes";

export interface ClipBoardState {
  productCodes: string[];
  invalidProductCodes: string[];
  isValidatingProductCodes: boolean;
  currentAction: string | null;
  validProductIds: string[];
  productIdCodes: ProductIdCodes[];
}

const initialState: ClipBoardState = {
  productCodes: [],
  invalidProductCodes: [],
  isValidatingProductCodes: false,
  currentAction: null,
  validProductIds: [],
  productIdCodes: [],
};

export const ClipBoardReducer = (
  state: ClipBoardState = initialState,
  action,
) => {
  switch (action.type) {
    case SET_CLIPBOARD_PRODUCT_CODES: {
      const productCodes = action as SetClipBoardProductCodesAction;
      const items = productCodes.payload.productCodes;
      const filterCodes = new Set(items);
      const uniqueCodes = Array.from(filterCodes);
      return {
        ...state,
        productCodes: uniqueCodes,
        currentAction: null,
      };
    }
    case ADD_CLIPBOARD_PRODUCT_CODES: {
      const codes = action as AddClipBoardProductCodesAction;
      const updatedCodes = codes.payload.productCodes;
      return {
        ...state,
        productCodes: updatedCodes,
        currentAction: null,
      };
    }
    case CLEAR_CLIPBOARD:
      return {
        ...state,
        productCodes: [],
        invalidProductCodes: [],
        currentAction: null,
      };

    case VERIFY_CLIPBOARD_PRODUCT_CODES.REQUEST: {
      return {
        ...state,
        isValidatingProductCodes: true,
        currentAction: null,
        validProductIds: [],
        productIdCodes: [],
      };
    }
    case VERIFY_CLIPBOARD_PRODUCT_CODES.COMPLETE: {
      const invalidProductCodes = action.payload.invalidProductCodes;
      const currentAction = action.payload.currentAction;
      const productIdCodes: ProductIdCodes[] =
        action.payload.productIdCodes ?? [];
      // productIdCodes is built in the saga in clipboard order (productCodes[i]
      // paired with responses[i]), so deriving validProductIds from it here
      // preserves the pasted order regardless of API response timing.
      const validProductIds: string[] = [
        ...new Set(
          productIdCodes
            .filter((pc) => pc.productId)
            .map((pc) => pc.productId),
        ),
      ];
      return {
        ...state,
        invalidProductCodes,
        isValidatingProductCodes: false,
        currentAction,
        productIdCodes,
        validProductIds,
      };
    }
    case RESET_CLIPBOARD: {
      return initialState;
    }
    default:
      return state;
  }
};
